import React from 'react';

import { useAgeVerification } from '../../context/AgeVerificationContext';
import AgeVerificationModal from '../modals/AgeVerificationModal';

interface AgeVerificationWrapperProps {
  children: React.ReactNode;
}

const AgeVerificationWrapper: React.FC<AgeVerificationWrapperProps> = ({ children }) => {
  const { isVerified, setVerified } = useAgeVerification();

  const handleVerify = () => {
    setVerified(true);
  };

  return (
    <>
      {!isVerified && <AgeVerificationModal onVerify={handleVerify} />}
      <div className={!isVerified ? 'filter blur-sm' : ''}>{children}</div>
    </>
  );
};

export default AgeVerificationWrapper;
